export default __webpack_public_path__ + "static/0101-944d6018391630f0805c911a0f8dbd3c.png";